import * as tslib_1 from "tslib";
import { map, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { extractValueFromParams, trimSlash } from '@awp/core/utils';
import { AppConfig } from '@awp/core/config';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config/src/lib/app-config";
import * as i2 from "../../../content/src/lib/content.provider";
var ThemeContextResolver = /** @class */ (function () {
    function ThemeContextResolver(appConfig, contentProvider) {
        this.appConfig = appConfig;
        this.contentProvider = contentProvider;
    }
    ThemeContextResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var themeId = extractValueFromParams(route, 'themeId');
        return this.contentProvider.fetchRoot().pipe(take(1), map(function (p) {
            return tslib_1.__assign({}, p._embedded.properties, { themeId: themeId, themeUrl: trimSlash([trimSlash(_this.appConfig.BASE_HREF), themeId].join('/')) });
        }));
    };
    ThemeContextResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeContextResolver_Factory() { return new ThemeContextResolver(i0.ɵɵinject(i1.AppConfig), i0.ɵɵinject(i2.ContentProvider)); }, token: ThemeContextResolver, providedIn: "root" });
    return ThemeContextResolver;
}());
export { ThemeContextResolver };
